<template>
        <div class='selecionar-produto row'>
                <div class=' col-12 col-sm-6 produtoinfo text-center text-sm-left '>
                    <div class="nome">
                         {{produto.nome}}
                    </div>
                    <div class="preco mt-3 text-center text-sm-left">


                        R$ <input class='form-control d-inline-block' style="width:100px;" ref="preco" v-model="preco" @input="precoAlterado"   /> <div v-if="mudoupreco"  class='btn btn-primary' @click="atualizaPreco"> <b>salvar</b></div>
                    </div>                   
                </div>
                
                <div v-if="showQuatidade" class='col-12 col-sm-6 mt-4 mt-sm-0 produtoquantidade text-center ' >
                        Disponivel:
                        <quantidade-selector 
                            v-model="quantidade"
                            :max="Infinity"
                            :unidade="produto.medida"
                            :increment="produto.incremento || 1"
                        />
                        
                        <div style="position:absolute; text-align:center; width:100%;">
                            <small style="color:green">{{quantidadeStatus}}</small>
                        </div>


                        
                </div>

                <div class="col-12 text-center  text-sm-left mt-2">
                  <div class="btn-group mt-4" role="group" aria-label="Basic example">
                        <a  class=" btn-sm pointer" @click="editar">  <EditIcon /> Editar</a>
                        <a  class=" btn-sm pointer"  @click="apagar"> <Trash2Icon /> Apagar</a>
                    </div>
                </div>
                
        </div>
</template>


<script>

import debounce from 'lodash/debounce'

import { EditIcon, Trash2Icon } from 'vue-feather-icons'
import QuantidadeSelector from '@/components/elementos/quantidade-selector'
export default {
        components:{
            QuantidadeSelector,
            EditIcon,
            Trash2Icon
        },

        data(){
            return {
                quantidade:0,
                mudoupreco:false,
                preco:0,
                quantidadeStatus:''
            }
        },

        created:function(){
            
           this.atualizaQuantidadeDebounce = debounce( this.atualizaQuantidade ,800)
        


            this.quantidade = this.produto.disponivel || 0
            this.preco = this.produto.preco

            this.$watch('quantidade',()=>{
                if(this.qst) clearTimeout(this.qst)
                 this.quantidadeStatus = 'salvando'
                 this.atualizaQuantidadeDebounce();
            })
        },

        props:{
            produto:{
                default:{}
            },
            showQuatidade:{
                default:true,
            }
        },

        computed:{
        },

        watch:{

            'produto':function(){
                     this.quantidade = this.produto.disponivel
                     this.preco = this.produto.preco
            },
            
            // quantidade: function(qtdAtual, oldQuantidade){
            //     if( qtdAtual != oldQuantidade )
            //         this.atualizaQuantidadeDebounce();
                
                  
            // },

        },

        methods:{
            editar:function(){
                this.$router.push('/admin/produtos/'+this.produto.id)
                // this.$parent.produto = {...this.produto}
            },
            apagar:function(){
                var r = confirm("Deseja apagar \""+this.produto.nome+"\"?");
                if (r == true) {
                   this.$store.dispatch('removeProduto',this.produto)
                } else {
                return false
                }
             
            },
            precoAlterado:function(){
                setTimeout(()=>this.mudoupreco = true, 200)
            },
            atualizaPreco:function(v){
     
               let value = this.$refs['preco'].value;
               this.$store.dispatch('updateProduto', {...this.produto,preco:value} )
               this.mudoupreco = false
            },

         
            atualizaQuantidade:function(){
                    console.log("atualiza quantidade para:"+ this.quantidade )
                   this.$store.dispatch('updateProduto', {...this.produto, disponivel:Number(this.quantidade) } )
                   this.quantidadeStatus = 'salvo'
                    this.qst = window.setTimeout(()=>this.quantidadeStatus = '',300)
            }


            
        }

}

</script>

<style lang="stylus">

.selecionar-produto{
    
        display:flex;
        padding:1.5em 0.5em;

        border-top:1px dotted gray;

        .produtoinfo{
            text-align:left;
                
        }
}

</style>